import type {
  CoverageGapAnalysisData,
  CoverageGapAnalysisStartedData,
  CoverageGapAnalysisSuccessData,
} from '@newfront-insurance/ai-api';
import { CircleSpinnerInline, IconTick, colors, IconExternal2, TextLink } from '@newfront-insurance/core-ui';

export function CoverageGapAnalysisStatusCard({ data }: { data: CoverageGapAnalysisData }) {
  return (
    <div className="flex w-full flex-col gap-4 rounded-md border py-4 sm:px-4">
      {data.status === 'PROCESSING' ? (
        <div className="flex items-center gap-3">
          <CircleSpinnerInline />
          <div className="flex flex-col">
            <div className="text-steel-500 font-semibold">{`Analyzing ${(data as CoverageGapAnalysisStartedData).entityType?.toLowerCase()}...`}</div>
            <div className="text-muted-foreground">
              You can navigate away if you wish - Nova will keep working on your request.
            </div>
          </div>
        </div>
      ) : (
        <div className="flex items-center gap-3">
          <IconTick color={colors.grass['500']} size={16} />
          <div className="flex flex-col">
            <div className="text-steel-500 font-semibold">Your coverage gap analysis is ready to view</div>
            {(data as CoverageGapAnalysisSuccessData).totalGapCount && (
              <div className="text-muted-foreground">{`${(data as CoverageGapAnalysisSuccessData).totalGapCount} coverage issues found.`}</div>
            )}
          </div>
          <div className="ml-auto flex items-center gap-2">
            <TextLink href={(data as CoverageGapAnalysisSuccessData).resultsUrl} target="_blank" underline={false}>
              <div className="flex items-center gap-3">
                <IconExternal2 />
                View full analysis
              </div>
            </TextLink>
          </div>
        </div>
      )}
    </div>
  );
}
